export default "__VITE_ASSET__69490d11__"